export const SCENE_RECIPE_LIBRARY = {
  hero_opening: {
    id: "hero_opening",
    purpose: "Create a strong first impression with a focal asset, title hierarchy, and layered decoration.",
    minimumLayers: 6,
    requiredRoles: ["background", "hero_asset", "title_text"],
    recommendedRoles: ["foreground_decoration", "glow_or_halo", "supporting_text"],
    motionPresets: ["scale_in_center", "fade_up", "settle_and_hold"],
  },
  devotional_opening: {
    id: "devotional_opening",
    extends: "hero_opening",
    purpose: "Create a devotional opening with calm reveal motion and separate movable festival assets.",
    minimumLayers: 8,
    requiredRoles: ["static_stage_background", "ganesha_center_artwork", "opening_text_title"],
    recommendedRoles: [
      "hero_halo_glow",
      "marigold_top_garland",
      "flower_offering_left",
      "flower_offering_right",
      "diya_glow_overlay",
    ],
    motionPresets: ["slide_from_top", "scale_in_center", "move_from_left_to_target", "move_from_right_to_target"],
  },
  readable_detail_card: {
    id: "readable_detail_card",
    purpose: "Present host or invitation details with a readable panel and premium decorative support.",
    minimumLayers: 6,
    requiredRoles: ["readable_panel", "scene_title", "scene_details"],
    recommendedRoles: ["subtle_watermark", "divider", "corner_ornament", "side_accent_bar"],
    motionPresets: ["fade_up", "staggered_text_reveal"],
  },
  program_schedule_card: {
    id: "program_schedule_card",
    extends: "readable_detail_card",
    purpose: "Present date, time, program highlights, and prasad/agenda details with high readability.",
    minimumLayers: 7,
    requiredRoles: ["readable_details_card", "scene_title", "scene_details"],
    recommendedRoles: ["program_icon_badge", "small_diya_icon", "temple_bell_icon", "modak_icon"],
    motionPresets: ["staggered_text_reveal"],
  },
  venue_rsvp_card: {
    id: "venue_rsvp_card",
    extends: "readable_detail_card",
    purpose: "Present venue, address, and RSVP/contact details in a clear mobile-safe card.",
    minimumLayers: 7,
    requiredRoles: ["venue_details_card", "venue_title", "venue_details"],
    recommendedRoles: ["rangoli_floor_accent", "marigold_side_accents", "diya_glow_overlay"],
    motionPresets: ["staggered_text_reveal", "settle_and_hold"],
  },
  closing_blessing: {
    id: "closing_blessing",
    purpose: "Close with a calm blessing, emotional hold, and restrained devotional decoration.",
    minimumLayers: 6,
    requiredRoles: ["closing_background", "closing_text_title"],
    recommendedRoles: ["ganesha_center_artwork", "settled_floral_frame", "soft_particle_overlay"],
    motionPresets: ["fade_up", "soft_pulse", "settle_and_hold"],
  },
};

export const GANESH_CHATURTHI_SCENE_RECIPE_MAP = {
  opening_blessing: "devotional_opening",
  "scene-ganesh-opening": "devotional_opening",
  host_invitation: "readable_detail_card",
  "scene-ganesh-host": "readable_detail_card",
  puja_program_details: "program_schedule_card",
  "scene-ganesh-details": "program_schedule_card",
  venue_rsvp: "venue_rsvp_card",
  "scene-ganesh-rsvp": "venue_rsvp_card",
  closing_blessing: "closing_blessing",
  "scene-ganesh-closing": "closing_blessing",
};

export function getSceneRecipeMapForFamily(family = {}) {
  if (family?.draftBuilder === "ganesh_chaturthi" || family?.id === "ganesh_chaturthi_mobile_video_v1") {
    return GANESH_CHATURTHI_SCENE_RECIPE_MAP;
  }

  return family?.sceneRecipeMap || {};
}

export function getRecipeMetadata(recipeId) {
  return SCENE_RECIPE_LIBRARY[recipeId] || null;
}
